import { useEffect, useState } from 'react';

import { unwrapResult } from '@reduxjs/toolkit';
import Alert from 'react-bootstrap/Alert';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { Pagination } from '../../components/Pagination';

import { SkuForm } from './forms/SkuForm';

import { createSku, fetchListSku, selectSkuEntity } from './skuSlice';

export function Sku() {
  const dispatch = useDispatch();
  const sku = useSelector(selectSkuEntity);
  const [alert, setAlert] = useState(null);
  const [page, setPage] = useState(1);
  const [skuId, setSkuId] = useState('');

  useEffect(() => {
    dispatch(fetchListSku({ page }));
  }, [dispatch, page]);

  return (
    <Row>
      <Col>
        <h4>Danh Sách SKU</h4>
        <Form
          inline
          onSubmit={(e) => {
            e.preventDefault();
            setPage(1);
            dispatch(fetchListSku({ page: 1, skuId }));
          }}
        >
          <Form.Label htmlFor="searchFormSkuId" srOnly>
            Mã sku
          </Form.Label>
          <Form.Control
            className="mb-2 mr-sm-2"
            id="searchFormSkuId"
            placeholder="Nhập mã sku"
            value={skuId}
            onChange={(e) => setSkuId(e.target.value)}
          />
          <Button type="submit" className="mb-2">
            Tìm kiếm
          </Button>
        </Form>
        <hr />
        <Table bordered responsive size="sm">
          <thead>
            <tr>
              <th>Mã SKU</th>
              <th>Tên SKU</th>
              <th>Màu Sắc</th>
              <th>Hình Ảnh</th>
              <th>Hướng Dẫn</th>
              <th>Thao Tác</th>
            </tr>
          </thead>
          <tbody>
            {sku.ids.map((id) => (
              <tr key={id}>
                <td>{sku.entities[id].skuId}</td>
                <td>{sku.entities[id].skuName}</td>
                <td>{sku.entities[id].color}</td>
                <td>
                  {sku.entities[id].skuPictures.map((item, index) => (
                    <img
                      alt=""
                      className="img-thumbnail"
                      key={index}
                      src={item}
                      width={40}
                    />
                  ))}
                </td>
                <td>
                  {!!sku.entities[id].guideLink && (
                    <a
                      rel="noreferrer"
                      href={sku.entities[id].guideLink}
                      target="_blank"
                    >
                      Hướng Dẫn
                    </a>
                  )}
                </td>
                <td>
                  <Link
                    to={{
                      pathname: '/admin/sku/edit',
                      state: sku.entities[id],
                    }}
                  >
                    Chỉnh sửa
                  </Link>
                  {' | '}
                  <Link
                    to={{
                      pathname: `/admin/sku/${id}/products`,
                      state: sku.entities[id],
                    }}
                  >
                    QL Serial
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <Pagination
          currentPage={page}
          totalItem={sku.total}
          onPageChange={(page) => setPage(page)}
        />
      </Col>
      <Col md={3}>
        <h4>Tạo SKU</h4>
        <hr />
        <SkuForm
          alert={
            alert && <Alert variant={alert.variant}>{alert.content}</Alert>
          }
          onSubmit={async (data, e) => {
            setAlert(null);

            try {
              const result = await dispatch(
                createSku({
                  ...data,
                  skuPictures: data.skuPictures.split('\n'),
                })
              );

              unwrapResult(result);
              setAlert({ variant: 'success', content: 'Thành công!' });
              e.target.reset();
            } catch (e) {
              setAlert({ variant: 'danger', content: e.message });
            }
          }}
        />
      </Col>
    </Row>
  );
}
